import { render, staticRenderFns } from "./PageOpportunityTasks.vue?vue&type=template&id=10f7a69e"
import script from "./PageOpportunityTasks.vue?vue&type=script&lang=js"
export * from "./PageOpportunityTasks.vue?vue&type=script&lang=js"
import style0 from "./PageOpportunityTasks.vue?vue&type=style&index=0&id=10f7a69e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports